import { useReducer } from 'react';
import reducer, { defaultState } from './reducer';
import logger from 'use-reducer-logger';
import * as actions from './actions';

export default function useVoidReservation() {

    const [state, dispatch] = useReducer(logger(reducer), defaultState);

    const voidReservation = actions.voidReservation(dispatch);

    return {
        state,
        voidReservation
    }
}